import { render, staticRenderFns } from "./challengeContiributions.vue?vue&type=template&id=2ed9b9ea&scoped=true&"
import script from "./challengeContiributions.vue?vue&type=script&lang=js&"
export * from "./challengeContiributions.vue?vue&type=script&lang=js&"
import style0 from "./challengeContiributions.vue?vue&type=style&index=0&id=2ed9b9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9b9ea",
  null
  
)

export default component.exports